<template>
    <div class="footer-box">
        <div class="main-bar flex b">
            <div class="lxwm">
                <h3>联系我们</h3>
                <ul class="info">
                    <li class="flex">
                        <img src="@/assets/images/icon_tel.png" alt="">
                        <b>020-84507853</b>
                    </li>
                    <!--<li class="flex">-->
                        <!--<img src="@/assets/images/icon_corp.png" alt="">-->
                        <!--<span>北京靠谱前程网络技术有限公司</span>-->
                    <!--</li>-->
                    <li class="flex">
                        <img src="@/assets/images/icon_address.png" alt="">
                        <span>广州市番禺区汉溪大道东 保利大都汇C4栋2105</span>
                    </li>
                </ul>
            </div>
            <div class="r">
                <img src="@/assets/images/qrcode.jpg" alt="">
                <p>融之队公众号</p>
            </div>
        </div>
        <a href="https://beian.miit.gov.cn/" class="col-666">京ICP备2021032491号-1 融之队ICP备案号 Copyright © 2020 融之队</a>
    </div>
</template>

<script>
  export default {
    name: ""
  };
</script>

<style scoped  lang="less" type="text/less">
    .footer-box{
        background: #eaeaea;
        padding-top: 40px;
        padding-bottom: 50px;
        position: relative;
        >a{
            display: block;
            text-align: center;
            font-size: 13px;
            position: relative;
            top:20px;
        }
        h3{
            height: 24px;
            font-size: 24px;
            font-weight: 500;
            line-height: 24px;
            position: relative;
            margin-bottom: 56px;
        }
        h3::after{
            content: '';
            position: absolute;
            background: #229E7F;
            width: 30px;
            height: 4px;
            left: 0;
            bottom: -10px;
        }
        .info{
            font-size: 16px;
            li{
                margin-bottom: 24px;
            }
            li:last-child{
                margin-bottom: 0;
            }
            b{
                font-size: 24px;
                line-height: 24px;
            }
            img{
                margin-right: 14px;
                width: 26px;
            }
        }
        .r{
            img{
                width: 160px;
            }
            p{
                text-align: center;
                padding-top: 15px;
            }
        }
    }
</style>
